import React from 'react'

interface NocfoIconProps {
  className?: string
  size?: number | string
}

export const NocfoIcon: React.FC<NocfoIconProps> = ({ className, size }) => (
  <svg
    className={className}
    viewBox="0 0 144 144"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    aria-hidden="true"
    focusable="false"
    role="presentation"
  >
    <g transform="matrix(1.37127,0,0,1.37127,-191.978,-54.8509)">
      <path
        d="M192.506,40C221.485,40 245.012,63.527 245.012,92.506C245.012,121.485 221.485,145.012 192.506,145.012C163.527,145.012 140,121.485 140,92.506C140,63.527 163.527,40 192.506,40ZM213.717,111.061C216.06,108.718 216.06,104.919 213.717,102.576C209.009,97.868 201.456,90.316 196.749,85.608C194.405,83.265 190.606,83.265 188.263,85.608C183.555,90.316 176.003,97.868 171.295,102.576C168.952,104.919 168.952,108.718 171.295,111.061C176.003,115.769 183.555,123.321 188.263,128.029C190.606,130.372 194.405,130.372 196.749,128.029C201.456,123.321 209.009,115.769 213.717,111.061ZM202.404,69.124C203.154,68.374 203.576,67.356 203.576,66.295C203.576,65.234 203.154,64.217 202.404,63.467C200.299,61.362 197.439,58.502 195.334,56.397C194.584,55.647 193.567,55.225 192.506,55.225C191.445,55.225 190.427,55.647 189.677,56.397C187.573,58.502 184.712,61.362 182.608,63.467C181.857,64.217 181.436,65.234 181.436,66.295C181.436,67.356 181.857,68.374 182.608,69.124C184.712,71.228 187.573,74.089 189.677,76.193C190.427,76.944 191.445,77.365 192.506,77.365C193.567,77.365 194.584,76.944 195.334,76.193C197.439,74.089 200.299,71.228 202.404,69.124Z"
        fill="currentColor"
      />
    </g>
  </svg>
)
